var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 88,
    viewBox: "0 0 85 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_03",
    clipPath: "url(#clip0_2434_1627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8245 31.7829C60.567 29.9505 54.5556 30.895 49.1876 33.4227C41.0809 37.2403 34.4387 44.6677 30.6208 51.7085C28.2207 56.1331 28.2107 60.3101 26.9152 65.37C26.8626 65.5749 26.6492 65.6593 26.4384 65.5583C26.2283 65.4583 26.0992 65.2096 26.1525 65.0056C27.4631 59.8865 27.4889 55.6684 29.9166 51.1917C33.7878 44.0529 40.5276 36.5268 48.7477 32.6552C54.2637 30.0577 60.4473 29.1057 66.8779 30.9887C67.0946 31.0521 67.2582 31.2806 67.2435 31.4999C67.2288 31.7192 67.0411 31.8463 66.8245 31.7829Z",
    fill: "url(#paint0_linear_2434_1627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6603 66.0022C25.6639 65.9836 25.6907 65.8608 25.7019 65.7531C25.751 65.3074 25.7659 64.5037 25.726 63.4754C25.5882 60.0256 24.8283 54.0606 22.4388 50.5399C22.3009 50.3368 22.3257 50.088 22.4935 49.9838C22.6614 49.8796 22.9089 49.9587 23.0467 50.1618C25.533 53.8251 26.3686 60.028 26.5112 63.6173C26.53 64.0979 26.5378 64.5328 26.5347 64.9076C27.1573 64.094 27.7547 63.2602 28.3431 62.415C30.0359 59.9809 32.0671 58.3616 34.7814 57.1454C34.9624 57.0637 35.2069 57.1709 35.325 57.3839C35.4438 57.5964 35.3924 57.8361 35.2107 57.9169C32.5985 59.0881 30.6415 60.6458 29.0118 62.9884C28.2426 64.0928 27.4568 65.1789 26.6241 66.2261C26.5412 66.3303 26.3225 66.598 26.2851 66.6291C26.0718 66.8065 25.8439 66.6288 25.795 66.5873C25.7712 66.5675 25.487 66.3055 25.6603 66.0022ZM26.3701 66.5073C26.3652 66.5155 26.3609 66.5247 26.3552 66.5335C26.3602 66.5267 26.3645 66.5175 26.3701 66.5073Z",
    fill: "url(#paint1_linear_2434_1627)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2434_1627",
    x1: 62.4112,
    y1: 37.3559,
    x2: 36.3418,
    y2: 45.7358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90205D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4352",
    stopOpacity: 0.969
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2434_1627",
    x1: 34.8829,
    y1: 59.8235,
    x2: 28.8884,
    y2: 63.8461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90205D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4352",
    stopOpacity: 0.969
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2434_1627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 54.5236,
    fill: "white",
    transform: "matrix(-0.620652 -0.784086 -0.784086 0.620652 84.957 53.6836)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow03);
export default __webpack_public_path__ + "static/media/Arrow_03.7c829090.svg";
export { ForwardRef as ReactComponent };